import { render, staticRenderFns } from "./FormOtherDocuments.vue?vue&type=template&id=d2ed01b0"
import script from "./FormOtherDocuments.vue?vue&type=script&lang=js"
export * from "./FormOtherDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports